import axios from '../index'

export default {
    getInstitucion () {
        return axios.get('/instituciones/usuario')
    },
    getCiclosEscolares (institucionId) {
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/'+ institucionId)
    },
    getConfiguracionDocumentos(params){
        return axios.get('/documentos/filtrar', {params})
    },
    getConfiguracionDocumentosExternos(params){
        return axios.get('/documentos/filtrar', {params})
    },
    postGuardarDocumento(formData){
        return axios.post('/documentos/archivo/guardar', formData)
    },
    postGuardarDocumentoInformacion(formData){
        return axios.post('/documentos/guardar', formData)
    },
    postActualizarDocumentoInformacion(formData){
        return axios.post('/documentos/actualizar', formData)
    }
}